import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import LayersIcon from '@material-ui/icons/Layers';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { Link } from 'react-router-dom'

 

export const mainListItems = (
  <div>
    <Link className="linkButton" to="/estadisticas">
      <ListItem button>
        <ListItemIcon>
          <DashboardIcon className="menuIcon" />
        </ListItemIcon>
        <ListItemText primary="Estadísticas" />
      </ListItem>
    </Link>
        
    <Link className="linkButton" to="/calendario">
      <ListItem button>
        <ListItemIcon>         
          <LayersIcon className="menuIcon"/>
        </ListItemIcon>
        <ListItemText primary="Turnos" />
      </ListItem>
    </Link>

    <Link className="linkButton" to="/pacientes">
      <ListItem button>
        <ListItemIcon>
          <PeopleIcon className="menuIcon"/>
        </ListItemIcon>
        <ListItemText primary="Pacientes" />
      </ListItem>
    </Link>
  </div>
);

export const secondaryListItems = (
  <div>
    <ListSubheader inset>Saved reports</ListSubheader>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Current month" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Last quarter" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Year-end sale" />
    </ListItem>
  </div>
);